var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { BusyIndicator, ControllerButton, CreateSubModelMessage, DeleteModelMessage, LayoutCreationFinishedMessage, LinkToModelFacet, LocalTransformFacet, ModuleId, NetworkLocalOnly, RemoveModelMessage, RemoveFacetFromModelMessage, UpdateFacetOnModelMessage } from "flavr-common";
import { isInteractionMessage, isMessageFromModule, isScriptMessage, isSessionMessage, MessageHandler, ModelEventHandler, ModelEventType, Service } from "@modules/module";
import { isModelPartOfScene, modelIsSessionModel, modelPool } from "@modules/model";
/**
 * Handles PeerModelMessages that originate from _this_ user and (mostly) will be forwarded to all other users.
 * This applies to almost all Messages that inherit from ModelMessage.
 */
export class PeerModelMessageHandler extends Service {
    constructor(connection, peerMgr) {
        super(connection);
        this.peerMgr = peerMgr;
        this.localOnlyModels = [];
        connection.subscribeByType(UpdateFacetOnModelMessage, this.handleModelMessage.bind(this), `(?!${BusyIndicator.typestatic})`);
    }
    handleModelMessage(msg, meta) {
        if (isSessionMessage(meta))
            return;
        if (meta.transport === "peer")
            return;
        if (meta.transport === "local" || meta.transport === "internal")
            return;
        if (isMessageFromModule(meta, ModuleId.REPLAY))
            return;
        const model = modelPool.getModel(msg.uid);
        if (model === undefined)
            return;
        if (!modelIsSessionModel(model))
            return;
        if (this.ignoreModelMessage(model))
            return;
        if (isModelPartOfScene(model)) {
            if (UpdateFacetOnModelMessage.is(msg) &&
                LocalTransformFacet.is(msg.facet) &&
                model.getFacet(LinkToModelFacet) !== undefined)
                return;
            if (UpdateFacetOnModelMessage.is(msg) ||
                (CreateSubModelMessage.is(msg) && (isScriptMessage(meta) || isInteractionMessage(meta))) ||
                RemoveModelMessage.is(msg) ||
                DeleteModelMessage.is(msg) ||
                RemoveFacetFromModelMessage.is(msg)) {
                this.peerMgr.broadcastBusMessage(msg);
            }
            return;
        }
        if (UpdateFacetOnModelMessage.is(msg) && ControllerButton.is(msg.facet)) {
            this.peerMgr.broadcastBusMessage(msg);
        }
    }
    handleNetworkLocalOnlyMessage(msg, meta) {
        if (isSessionMessage(meta))
            return;
        if (isMessageFromModule(meta, ModuleId.REPLAY))
            return;
        const model = modelPool.getModel(msg.uid);
        if (model === undefined)
            return;
        if (!modelIsSessionModel(model))
            return;
        if (!this.localOnlyModels.includes(model.getUID())) {
            this.localOnlyModels.push(model.getUID());
        }
    }
    handleModelDestroyedEvent(model, destroyPermanently, metaData) {
        if (destroyPermanently)
            this.handleModelMessage(new DeleteModelMessage(model.getUID()), metaData);
    }
    /// Private helper methods ///
    ignoreModelMessage(model) {
        for (const parentModelUID of this.localOnlyModels) {
            const parentModel = modelPool.getModel(parentModelUID);
            if (parentModel === undefined)
                return true;
            if (parentModel.isAncestorOfOrEquals(model))
                return true;
        }
        return false;
    }
}
__decorate([
    MessageHandler(CreateSubModelMessage, RemoveModelMessage, DeleteModelMessage, RemoveFacetFromModelMessage, LayoutCreationFinishedMessage)
], PeerModelMessageHandler.prototype, "handleModelMessage", null);
__decorate([
    MessageHandler(NetworkLocalOnly)
], PeerModelMessageHandler.prototype, "handleNetworkLocalOnlyMessage", null);
__decorate([
    ModelEventHandler(ModelEventType.MODEL_DESTROYED)
], PeerModelMessageHandler.prototype, "handleModelDestroyedEvent", null);
